<div *ngIf="item" [className]="item?.class">
  <a mat-button color="primary" routerLink="{{item.link}}" (click)="item.icon === 'download' || item.icon === 'cloud_download' ? openDownloadDialog(item.type) : ''">
    <mat-icon>{{item.icon}}</mat-icon>
    <span class="button-text">{{item.title}}</span>
  </a>
</div>
